<template>
<!-- <Sidebar :showSidebar="showSidebar" /> -->
<main class="main-content">
    <!-- Craft weapon list -->
    <div class="craft-weapon_list linear-gradient-color mb-3">
        <div class="row justify-content-center">
            <div class="col-md-4">
                <div class="left-block">
                    <div class="craft-card linear-gradient-color">
                        <div class="craft-card_img" v-show="selectedCard!=null">
                            <img :src="selectedWeapon" class="p-2" alt="" />
                        </div>
                    </div>
                    <h6 class="text-white text-capitalize mt-2 text-center font-weight-bold text-truncate weapon-name" v-if="selectedWeapon">
                        {{selectedCard}}
                    </h6>
                    <!-- Craft card power -->
                    <div class="d-flex justify-content-center justify-content-around">
                        <div class="d-flex align-items-center">
                            <img src="/weapsmithing/images/material_wood.png" class="w-20" alt="" />
                            <h6>x5</h6>
                        </div>
                        <div class="d-flex align-items-center">
                            <img src="/weapsmithing/images/material_MetalBar.png" class="w-20" alt="" />
                            <h6>x5</h6>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center justify-content-around">
                        <div class="d-flex align-items-center">
                            <img src="/weapsmithing/images/material_leather.png" class="w-20" alt="" />
                            <h6>x5</h6>
                        </div>
                        <div class="d-flex align-items-center">
                            <img src="/weapsmithing/images/coins.png" class="w-20" style="width:24px;height:25px" alt="" />
                            <h6>x1</h6>
                        </div>
                    </div>
                    <button class="btn btn-craft text-uppercase border-0" @click="craft()">craft</button>
                </div>
            </div>
            <div class="col-md-8">
                <div class="right-block p-3 linear-gradient-color">
                    <div class="scrollbar">
                        <div class="row">
                            <div class="col-md-4 mb-2">
                                <div class="craft-card linear-gradient-color">
                                    <div class="weapon-card linear-gradient-color">
                                        <a href="#" @click.prevent="setWeapon('Sword')">
                                            <div class="weapon-card_img"><img src="/weapsmithing/images/Sword.png" alt="">
                                            </div>
                                        </a></div>
                                    <h6 class="text-white text-capitalize mt-2 text-center font-weight-bold text-truncate weapon-name">Sword</h6>
                                </div>
                            </div>
                            <div class="col-md-4 mb-2">
                                <div class="craft-card linear-gradient-color">
                                    <div class="weapon-card linear-gradient-color">
                                      <a href="#" @click.prevent="setWeapon('Spear')">
                                            <div class="weapon-card_img"><img src="/weapsmithing/images/Spear.png" alt=""></div>
                                        </a></div>
                                    <h6 class="text-white text-capitalize mt-2 text-center font-weight-bold text-truncate weapon-name">Spear</h6>
                                </div>
                            </div>
                            <div class="col-md-4 mb-2">
                                <div class="craft-card linear-gradient-color">
                                    <div class="weapon-card linear-gradient-color"><a href="#" @click.prevent="setWeapon('Lance')">
                                            <div class="weapon-card_img"><img src="/weapsmithing/images/Lance.png" alt=""></div>
                                        </a></div>
                                    <h6 class="text-white text-capitalize mt-2 text-center font-weight-bold text-truncate weapon-name">Lance</h6>
                                </div>
                            </div>
                            <div class="col-md-4 mb-2">
                                <div class="craft-card linear-gradient-color">
                                    <div class="weapon-card linear-gradient-color"><a href="#" @click.prevent="setWeapon('Katana')">
                                            <div class="weapon-card_img"><img src="/weapsmithing/images/Katana.png" alt=""></div>
                                        </a></div>
                                    <h6 class="text-white text-capitalize mt-2 text-center font-weight-bold text-truncate weapon-name">Katana</h6>
                                </div>
                            </div>
                            <div class="col-md-4 mb-2">
                                <div class="craft-card linear-gradient-color">
                                    <div class="weapon-card linear-gradient-color"><a href="#" @click.prevent="setWeapon('Hammer')">
                                            <div class="weapon-card_img"><img src="/weapsmithing/images/Hammer.png" alt=""></div>
                                        </a></div>
                                    <h6 class="text-white text-capitalize mt-2 text-center font-weight-bold text-truncate weapon-name">Hammer</h6>
                                </div>
                            </div>
                            <div class="col-md-4 mb-2">
                                <div class="craft-card linear-gradient-color">
                                    <div class="weapon-card linear-gradient-color"><a href="#" @click.prevent="setWeapon('Dagger')">
                                            <div class="weapon-card_img"><img src="/weapsmithing/images/Dagger.png" alt=""></div>
                                        </a></div>
                                    <h6 class="text-white text-capitalize mt-2 text-center font-weight-bold text-truncate weapon-name">Dagger</h6>
                                </div>
                            </div>
                            <div class="col-md-4 mb-2">
                                <div class="craft-card linear-gradient-color">
                                    <div class="weapon-card linear-gradient-color"><a href="#" @click.prevent="setWeapon('Bow')">
                                            <div class="weapon-card_img"><img src="/weapsmithing/images/Bow.png" alt=""></div>
                                        </a></div>
                                    <h6 class="text-white text-capitalize mt-2 text-center font-weight-bold text-truncate weapon-name">Bow</h6>
                                </div>
                            </div>
                            <div class="col-md-4 mb-2">
                                <div class="craft-card linear-gradient-color">
                                    <div class="weapon-card linear-gradient-color"><a href="#" @click.prevent="setWeapon('Axe')">
                                            <div class="weapon-card_img"><img src="/weapsmithing/images/Axe.png" alt=""></div>
                                        </a></div>
                                    <h6 class="text-white text-capitalize mt-2 text-center font-weight-bold text-truncate weapon-name">Axe</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>
</template>

<script>
import {
    mapGetters
} from "vuex";
import ApiService from "@/services";
import "vue-loading-overlay/dist/vue-loading.css";
import {
    useToast
} from "vue-toastification";
const toast = useToast();
export default {
    name: "Craft",
    computed: {
        ...mapGetters(["loaded", "wsw", "wsm", "wsl","mcc"]),
    },
    data() {
        return {
            showMenu: false,
            selectedCard: null,
            recipe: null,
            selectedWeapon: "",
            showSidebar: false,
        };
    },
    methods: {
        setWeapon(item) {
            this.selectedCard = item;
            this.selectedWeapon = `/weapsmithing/images/${item}.png`;
        },
        async craft() {
            if (this.wsw < 5 && this.wsl < 5 && this.wsm < 5 && this.mcc < 1) {
                toast.error("Missing balance, you need wood,metal and leather to craft.");
                return;
            }
            const data = {
                account: localStorage.getItem("wax_user"),
                weapon_name: this.selectedCard
            };
            await ApiService.craft(data, ((res) => {
                if (res.processed) {
                    toast.success("Item has been crafted.");
                        this.selectedCard = null;
                        this.selectedWeapon = '';
                }
            }), ((error) => {
                this.error = ApiService.errorFormat(error)
                toast.error(this.error);
            }));
        },
        getImage(hash) {
            return ApiService.getImgUrl(hash, false);
        },
    },
};
</script>

<style>
</style>
